export const BNK_STMT_updatePreviousScreenReducer = {
  BNK_STMT_updatePreviousScreen: (state, action) => {
    state.previousScreen = action.payload;
  },
};
